import Icn from '../components/Icn';
import { colors } from '../maps/colors';

function StoreHeader(props) {
    return (<div style={{ display: 'inline-block', width: '16.6%', textAlign: 'center' }}><Icn style={{ position: 'relative', top: 10 }}>{props.children}</Icn></div>)
}

export default function StoresHeader() {
    return (
        <div style={{ height: 44, background: colors.LIGHT_GREEN }}>
            {
                ['user', 'store', 'edge', 'sensor', 'camera', 'field'].map(section => <StoreHeader key={section}>{section}</StoreHeader>)
            }
        </div>
    )
}